import { axiosInstance as axios } from "services";

export const fetchPromotionalCodeDetails = async (id) => {
  const { data } = await axios.get(`/admin/subscription/promotional-codes/${id}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch promotional code details");
  return data;
};

